import React from "react";
import Info from "../../../../icons/infoIcon.svg?react";
import type {
  Question,
  Response,
  ResponseStatus,
} from "./ReviewResponseModel.types";
import ResponseCard from "./ResponseCard";

interface ResponsePanelProps {
  question: Question | undefined;
  responses: Response[];
  responseStatusMap: Record<string, ResponseStatus>;
  onUpdateResponseStatus: (
    responseId: string,
    updates: Partial<ResponseStatus>,
  ) => void;
  onShowAIEvaluation: (response: Response) => void;
  onShowClauseInfo: () => void;
  onRegenerateQuestions: (responseId: string) => void;
  isRegenerating: Record<string, boolean>;
}

const ResponsePanel: React.FC<ResponsePanelProps> = ({
  question,
  responses,
  responseStatusMap,
  onUpdateResponseStatus,
  onShowAIEvaluation,
  onShowClauseInfo,
  onRegenerateQuestions,
  isRegenerating,
}) => {
  if (!question) {
    return (
      <div className="review-response-panel">
        <div className="review-no-question">
          Select a question to view responses
        </div>
      </div>
    );
  }

  if (!responses || responses.length === 0) {
    return (
      <div className="review-response-panel">
        <div className="review-question-header-section">
          <div className="review-question-label-row">
            <span className="review-question-label">Question</span>
            <Info
              className="review-info-icon"
              onClick={onShowClauseInfo}
              title="View clause information"
            />
          </div>
          <div className="review-question-text-content">
            {question.questionText}
          </div>
        </div>
        <div className="review-no-question">
          No responses available for this question
        </div>
      </div>
    );
  }

  return (
    <div className="review-response-panel">
      <div className="review-response-cards-container">
        <div className="review-question-header-section">
          <div className="review-question-label-row">
            <span className="review-question-label">Question</span>

            <Info
              className="review-info-icon"
              onClick={onShowClauseInfo}
              title="View clause information"
            />
          </div>
          <div className="review-question-text-content">
            {question.questionText}
          </div>
        </div>

        <div className="review-responses-header">
          <span className="review-responses-count">
            Responses ({responses.length})
          </span>
        </div>

        {responses.map((response) => (
          <ResponseCard
            key={response.id}
            response={response}
            status={responseStatusMap[response.id]}
            onUpdateStatus={(updates) =>
              onUpdateResponseStatus(response.id, updates)
            }
            onShowAIEvaluation={() => onShowAIEvaluation(response)}
            onRegenerateQuestions={() => onRegenerateQuestions(response.id)}
            isRegenerating={isRegenerating[response.id] || false}
          />
        ))}
      </div>
    </div>
  );
};

export default ResponsePanel;
